import { useAuthStore } from '@/stores/authStore'
import { hasFeature } from '@/lib/planFeatures'
import type { PlanFeatureKey } from '@/types/api'

/**
 * r7-25 — o plano do usuario libera esta feature? Le o `plan_access` do `/auth/me`.
 * Usado para esconder botoes e desligar consultas de telas vizinhas (a API responderia
 * 403 `feature_not_in_plan`).
 */
export function usePlanFeature(feature: PlanFeatureKey): boolean {
  const user = useAuthStore((state) => state.user)
  return hasFeature(user, feature)
}
